
const Input = ({
  label,
  type = 'text',
  name,
  id,
  value,
  onChange,
  placeholder,
  error,
  required = false,
  disabled = false,
  autoComplete,
  endIcon,
  className = '',
  inputClassName = '',
  ...restProps
}) => {
  const inputId = id || name;

  return (
    <div className={`flex flex-col gap-1.5 w-full ${className}`}>
      {label && (
        <label className="label" htmlFor={inputId}>
          <span className="label-text">
            {label}
            {required && <span className="text-error ml-1">*</span>}
          </span>
        </label>
      )}
      <div
        className={`relative ${error ? 'tooltip tooltip-open tooltip-top w-full [--tooltip-color:#9ca3af] [--tooltip-text-color:#fff]' : ''}`}
        data-tip={error || undefined}
      >
        <input
          type={type}
          id={inputId}
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          disabled={disabled}
          required={required}
          autoComplete={autoComplete}
          aria-invalid={error ? 'true' : 'false'}
          className={`input input-bordered w-full hover:border-base-content/30 transition-colors ${endIcon ? 'pr-10' : ''} ${inputClassName}`}
          {...restProps}
        />
        {endIcon && (
          <div className="absolute inset-y-0 right-0 flex items-center pr-3 z-10">
            {endIcon}
          </div>
        )}
      </div>
    </div>
  );
};

export default Input;
